var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature389F5Be4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 96,
    viewBox: "0 0 172 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M49.1116 12.3291L54.4793 9.25757L132.646 54.3889L127.279 57.4604L49.1116 12.3291Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M127.279 57.475V57.4605L49.1116 12.3292L127.279 57.4605V57.475Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M127.28 57.4605L125.646 58.4023L76.1989 29.8602L47.4788 13.271L49.1124 12.3292L127.28 57.4605Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M125.646 58.4163L125.66 64.4L125.646 58.4163Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M76.1989 29.8595L47.4788 13.2703L76.1989 29.8595Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M104.043 45.9271L91.5719 38.7408L87.1523 36.1764L76.1981 29.8595L58.5488 19.6741L47.4634 13.2703L46.5153 13.8208L42.9125 15.8927L38.6971 18.2977L36.4946 19.5582L32.2792 21.9778L30.0767 23.2383L29.1286 23.7743L27.2615 24.8465L25.8613 25.6578L23.6733 26.9183H23.6588L20.4644 28.7439L19.4434 29.3379L17.2554 30.5984L15.0967 31.8299L13.0254 33.0179L9.23304 35.1912L5.01764 37.6252L0 40.4939L15.0675 49.187L20.4206 52.273L23.5858 54.113L27.1886 56.1848L29.041 57.257L46.3694 67.254L48.7032 68.6014L63.4936 77.135L65.6377 78.3665L75.4542 84.0315L78.1818 85.6107L82.441 83.1767L86.7877 80.6847L90.4488 78.5694L94.8246 76.0629L96.8667 74.8893L101.228 72.3973L103.285 71.2093L107.646 68.7173L109.688 67.5292L114.049 65.0372L116.106 63.8492L120.482 61.3427L125.645 58.4016L104.043 45.9271Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M132.646 54.3893L132.661 64.763L78.1962 95.9999L78.1816 85.6262L132.646 54.3893Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M78.1816 85.5535L78.1962 95.0144L131.363 64.5164V56.287L78.1962 86.7705V85.5535H78.1816Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M78.1818 85.6256L78.1964 95.9993L0.0291723 50.868L0 40.4943L78.1818 85.6256Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0.0142822 50.0132L78.1961 95.0141V86.7702L0.0142822 41.5665V50.0132Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M91.5719 38.7413C91.6157 39.3209 91.6302 39.9004 91.6302 40.4944C91.6302 55.6782 81.5366 69.2683 65.6377 78.3671L75.4542 84.032C91.3385 74.4987 101.972 61.0534 104.043 45.9276L91.5719 38.7413Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M87.1527 36.1776L76.1985 29.8606L58.5493 19.6753C64.6171 25.5721 68.1761 32.7583 68.1761 40.4951C68.1761 51.796 60.6059 61.8944 48.7036 68.6025L63.494 77.1362C78.1968 68.0665 87.4299 55.0125 87.4299 40.4951C87.4299 39.0463 87.3424 37.5974 87.1527 36.1776Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M46.5154 13.8218L42.9126 15.8936L38.6972 18.2987L36.4947 19.5592L32.2793 21.9787L30.0768 23.2392L29.1287 23.7753C36.4217 27.6727 41.0893 33.7143 41.0893 40.4949C41.0893 47.3044 36.378 53.3606 29.0411 57.2579L46.3695 67.2549C56.9882 60.6047 63.6249 51.0714 63.6249 40.4949C63.6249 29.9618 57.0466 20.4719 46.5154 13.8218Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M27.2614 24.8469L25.8611 25.6582L23.6732 26.9187C29.2014 30.2655 32.6875 35.1046 32.6875 40.4943C32.6875 45.913 29.1722 50.7811 23.5857 54.1134L27.1885 56.1852C33.4314 52.2879 37.355 46.6953 37.355 40.4943C37.355 34.3223 33.4751 28.7442 27.2614 24.8469Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.4645 28.7448L19.4435 29.3388L17.2556 30.5993L15.0968 31.8308C18.0432 34.149 19.8081 37.1915 19.8081 40.4949C19.8081 43.8127 18.0286 46.8553 15.0676 49.1879L20.4207 52.2739C24.4465 49.1155 26.8678 45.0008 26.8678 40.4949C26.8678 36.018 24.4611 31.9033 20.4645 28.7448Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.1116 9.43152L54.4793 6.35999L132.646 51.4913L127.279 54.5628L49.1116 9.43152Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.279 54.5774V54.5629L49.1116 9.43164L127.279 54.5629V54.5774Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.28 54.563L125.646 55.5047L76.1989 26.9626L47.4788 10.3734L49.1124 9.43164L127.28 54.563Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.646 55.5187L125.66 61.5024L125.646 55.5187Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1989 26.9619L47.4788 10.3727L76.1989 26.9619Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.043 43.0295L91.5719 35.8432L87.1523 33.2788L76.1981 26.9619L58.5488 16.7765L47.4634 10.3727L46.5153 10.9232L42.9125 12.9951L38.6971 15.4001L36.4946 16.6606L32.2792 19.0802L30.0767 20.3407L29.1286 20.8768L27.2615 21.9489L25.8613 22.7602L23.6733 24.0207H23.6588L20.4644 25.8463L19.4434 26.4403L17.2554 27.7008L15.0967 28.9323L13.0254 30.1203L9.23304 32.2936L5.01764 34.7276L0 37.5963L15.0675 46.2894L20.4206 49.3754L23.5858 51.2154L27.1886 53.2873L29.041 54.3594L46.3694 64.3564L48.7032 65.7038L63.4936 74.2375L65.6377 75.469L75.4542 81.1339L78.1818 82.7132L82.441 80.2791L86.7877 77.7871L90.4488 75.6718L94.8246 73.1653L96.8667 71.9917L101.228 69.4998L103.285 68.3117L107.646 65.8197L109.688 64.6317L114.049 62.1397L116.106 60.9516L120.482 58.4451L125.645 55.504L104.043 43.0295Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.646 51.4917L132.661 61.8654L78.1962 93.1023L78.1816 82.7287L132.646 51.4917Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1816 82.6559L78.1962 92.1168L131.363 61.6187V53.3893L78.1962 83.8729V82.6559H78.1816Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1818 82.728L78.1964 93.1017L0.0291723 47.9704L0 37.5967L78.1818 82.728Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0142822 47.1156L78.1961 92.1165V83.8726L0.0142822 38.6689V47.1156Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M91.5719 35.8443C91.6156 36.4238 91.6302 37.0034 91.6302 37.5974C91.6302 52.7812 81.5366 66.3713 65.6377 75.47L75.4542 81.135C91.3385 71.6016 101.972 58.1564 104.043 43.0305L91.5719 35.8443Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M87.1527 33.2797L76.1985 26.9627L58.5493 16.7774C64.6171 22.6742 68.1761 29.8604 68.1761 37.5972C68.1761 48.8982 60.6059 58.9965 48.7036 65.7047L63.494 74.2383C78.1968 65.1686 87.4299 52.1146 87.4299 37.5972C87.4299 36.1484 87.3424 34.6995 87.1527 33.2797Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M46.5154 10.9242L42.9126 12.996L38.6972 15.4011L36.4947 16.6616L32.2793 19.0812L30.0768 20.3416L29.1287 20.8777C36.4217 24.7751 41.0893 30.8167 41.0893 37.5973C41.0893 44.4068 36.378 50.463 29.0411 54.3604L46.3695 64.3573C56.9882 57.7072 63.6249 48.1738 63.6249 37.5973C63.6249 27.0642 57.0466 17.5744 46.5154 10.9242Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M27.2615 21.9503L25.8613 22.7616L23.6733 24.0221C29.2015 27.3689 32.6876 32.208 32.6876 37.5977C32.6876 43.0164 29.1723 47.8845 23.5858 51.2168L27.1886 53.2886C33.4315 49.3913 37.3552 43.7987 37.3552 37.5977C37.3552 31.4257 33.4752 25.8476 27.2615 21.9503Z",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.4645 25.847L19.4435 26.441L17.2556 27.7015L15.0968 28.933C18.0432 31.2512 19.8081 34.2937 19.8081 37.5971C19.8081 40.9149 18.0286 43.9575 15.0676 46.2901L20.4207 49.3761C24.4465 46.2177 26.8678 42.103 26.8678 37.5971C26.8678 33.1202 24.4611 29.0055 20.4645 25.847Z",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M64.7336 6.15747C64.7191 6.09951 64.7336 6.01258 64.7482 5.91117C64.7482 5.88219 64.7628 5.8677 64.7628 5.83872C64.792 5.72282 64.8212 5.60691 64.8795 5.47651C65.1275 4.85351 65.5942 4.18705 65.9151 3.9987C65.988 3.95523 66.061 3.94075 66.1047 3.95523C64.7774 3.59303 63.4501 3.2453 62.1373 2.89758C62.1227 2.89758 62.1081 2.89758 62.0935 2.91207C62.0206 2.95554 61.9185 3.10042 61.8747 3.23082C61.8602 3.27428 61.8456 3.31775 61.8456 3.34672C61.8456 3.36121 61.8456 3.36121 61.8456 3.36121C61.8456 3.3757 61.8456 3.39019 61.8456 3.40468C62.8229 4.36091 63.8001 5.31714 64.7774 6.25889C64.7482 6.22991 64.7336 6.20093 64.7336 6.15747Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M70.5672 11.8661C70.538 11.8082 70.5088 11.7502 70.4943 11.6633C70.4943 11.6488 70.4943 11.6198 70.4797 11.5909C70.4651 11.5184 70.4651 11.446 70.4651 11.359C70.4651 11.3301 70.4651 11.3156 70.4651 11.2866C70.4797 11.1852 70.4943 11.0548 70.5234 10.9244C70.5234 10.8954 70.538 10.8664 70.5526 10.823C70.5818 10.7215 70.6109 10.6056 70.6401 10.4752C70.6547 10.4318 70.6693 10.3883 70.6839 10.3449C70.7422 10.1855 70.8006 10.0261 70.8589 9.83776C71.5007 8.25852 72.6822 6.56338 73.5136 6.08527C73.6303 6.01283 73.7178 5.98385 73.8053 5.96936C73.8345 5.96936 73.8491 5.96936 73.8782 5.96936C73.922 5.96936 73.9658 5.95487 73.9949 5.96936C73.9949 5.96936 73.9949 5.96936 73.9804 5.96936C71.3548 5.27392 68.7293 4.59297 66.1038 3.89752C66.0601 3.88303 66.0017 3.89752 65.9142 3.94099C65.5933 4.12934 65.1266 4.7958 64.8786 5.4188C64.8202 5.56369 64.7911 5.67959 64.7619 5.78101C64.7619 5.80999 64.7473 5.83897 64.7473 5.85345C64.7327 5.95487 64.7181 6.0418 64.7327 6.09976C64.7473 6.14322 64.7619 6.18669 64.7765 6.20118C66.7164 8.08466 68.6564 9.98264 70.6109 11.8661C70.6255 11.8806 70.6255 11.8806 70.6401 11.8806C70.6109 11.9241 70.5818 11.8951 70.5672 11.8661Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M74.0251 6.02742C74.0105 6.02742 74.0105 6.01293 73.996 6.01293C73.9668 5.99845 73.923 6.01293 73.8793 6.01293C73.9376 5.99845 73.9814 5.99845 74.0251 6.02742Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M70.553 10.8661C70.553 10.8951 70.5384 10.924 70.5238 10.9675C70.5384 10.924 70.5384 10.8951 70.553 10.8661Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M70.6844 10.388C70.6698 10.4315 70.6552 10.4749 70.6406 10.5184C70.6552 10.4749 70.6698 10.4315 70.6844 10.388Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M73.5145 6.12891C73.6312 6.05647 73.7187 6.02749 73.8062 6.013C73.7187 6.02749 73.6312 6.05647 73.5145 6.12891Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M70.4952 11.6775C70.4952 11.663 70.4952 11.634 70.4806 11.605C70.4806 11.634 70.4806 11.6485 70.4952 11.6775Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M156.728 60.4601C156.698 60.4167 156.669 60.3442 156.655 60.2718C156.655 60.2573 156.655 60.2283 156.64 60.1993C156.626 60.1269 156.626 60.0545 156.626 59.9675C156.626 59.9385 156.626 59.9241 156.626 59.8951C156.64 59.7937 156.655 59.6633 156.684 59.5329C156.684 59.5039 156.698 59.4749 156.698 59.4459C156.728 59.33 156.757 59.2141 156.786 59.0982C156.801 59.0548 156.815 59.0113 156.83 58.9678C156.888 58.8085 156.946 58.6491 157.005 58.4607C157.647 56.8815 158.828 55.1864 159.659 54.7082C159.776 54.6358 159.864 54.6068 159.951 54.5923C159.951 54.5923 159.966 54.5923 159.966 54.5778C159.995 54.5778 160.01 54.5923 160.024 54.5923C160.082 54.5923 160.126 54.5923 160.17 54.6068C160.185 54.6068 160.185 54.6068 160.199 54.6068C158.157 53.4622 156.057 52.2742 153.912 51.0572L147.83 47.6234C144.096 45.5226 140.26 43.3494 136.351 41.1471L129.554 37.3077C128.941 36.96 128.328 36.6123 127.701 36.2645L113.713 28.3684C111.292 27.0065 108.885 25.6446 106.493 24.2971L104.713 23.2974C102.409 21.9935 100.119 20.704 97.8433 19.429L86.4078 12.9817C84.3365 11.8082 82.2945 10.6636 80.2816 9.53348L74.0241 5.99831C74.0241 5.99831 74.0095 5.99831 73.9949 5.99831C73.9512 5.98383 73.9074 5.98383 73.8491 5.98383C73.8199 5.98383 73.8053 5.98383 73.7761 5.98383C73.6886 5.99831 73.5865 6.04178 73.4844 6.09973C72.653 6.59234 71.4715 8.27299 70.8297 9.85222C70.7568 10.0261 70.6985 10.1999 70.6547 10.3593C70.6401 10.4028 70.6255 10.4462 70.6109 10.4897C70.5672 10.6056 70.538 10.7215 70.5234 10.8374C70.5234 10.8664 70.5088 10.8954 70.4943 10.9389C70.4651 11.0692 70.4505 11.1852 70.4359 11.3011C70.4359 11.33 70.4359 11.3445 70.4359 11.3735C70.4359 11.4604 70.4359 11.5329 70.4505 11.6053C70.4505 11.6343 70.4505 11.6488 70.4651 11.6778C70.4797 11.7502 70.5088 11.8226 70.538 11.8806C70.5526 11.9096 70.5818 11.9241 70.6109 11.953C70.6255 11.953 70.6255 11.9675 70.6401 11.982C72.6676 13.1266 74.7826 14.3146 76.9122 15.5172L83.0092 18.9654C86.7432 21.0662 90.5648 23.225 94.4739 25.4272L101.3 29.2811C101.913 29.6289 102.525 29.9766 103.138 30.3243L110.329 34.381C114.997 37.0179 119.693 39.6548 124.332 42.2772L126.17 43.3204C128.46 44.6098 130.735 45.8993 132.996 47.1743L144.461 53.6361C146.532 54.8097 148.559 55.9542 150.558 57.0843L156.83 60.6195C156.801 60.5326 156.757 60.5036 156.728 60.4601C156.728 60.4746 156.728 60.4746 156.728 60.4601Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M156.67 60.2714C156.67 60.2569 156.67 60.2279 156.656 60.199C156.656 60.2279 156.656 60.2569 156.67 60.2714Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M156.713 59.4604C156.713 59.4894 156.699 59.5184 156.699 59.5474C156.699 59.5184 156.713 59.4894 156.713 59.4604Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M160.054 54.6066C160.113 54.6066 160.156 54.6066 160.2 54.6211C160.156 54.6066 160.113 54.5921 160.054 54.6066Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M159.69 54.723C159.806 54.6506 159.894 54.6216 159.981 54.6071C159.894 54.6216 159.792 54.6506 159.69 54.723Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M156.859 58.9819C156.845 59.0254 156.83 59.0689 156.816 59.1123C156.83 59.0689 156.845 59.0254 156.859 58.9819Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M159.471 62.0542C159.428 62.0397 159.398 61.9962 159.369 61.9672C159.34 61.9238 159.325 61.8803 159.311 61.8223C159.311 61.8079 159.311 61.7934 159.311 61.7789C159.311 61.7644 159.311 61.7354 159.296 61.7064C159.282 61.634 159.282 61.5616 159.282 61.4746C159.282 61.4456 159.282 61.4312 159.282 61.4022C159.296 61.3008 159.311 61.1704 159.34 61.04C159.34 61.011 159.355 60.982 159.355 60.953C159.384 60.8371 159.413 60.7212 159.442 60.6053C159.457 60.5619 159.471 60.5184 159.486 60.4749C159.544 60.3156 159.603 60.1562 159.661 59.9678C160.303 58.3886 161.484 56.6934 162.316 56.2153C162.432 56.1429 162.52 56.1139 162.607 56.0994C162.636 56.0994 162.651 56.0994 162.68 56.0994C162.739 56.0994 162.782 56.0994 162.826 56.1139C162.826 56.1139 162.841 56.1139 162.855 56.1139L161.528 55.375C161.061 55.1142 160.609 54.8534 160.201 54.6361C160.201 54.6361 160.186 54.6361 160.171 54.6361C160.128 54.6216 160.084 54.6216 160.026 54.6216C160.011 54.6216 159.996 54.6071 159.967 54.6071C159.967 54.6071 159.953 54.6071 159.953 54.6216C159.865 54.6361 159.763 54.6796 159.661 54.7375C158.829 55.2301 157.648 56.9108 157.006 58.49C156.933 58.6639 156.875 58.8377 156.831 58.9971C156.817 59.0406 156.802 59.084 156.787 59.1275C156.744 59.2434 156.714 59.3593 156.7 59.4752C156.7 59.5042 156.685 59.5332 156.685 59.5622C156.656 59.6925 156.642 59.8085 156.627 59.9244C156.627 59.9533 156.627 59.9678 156.627 59.9968C156.627 60.0837 156.627 60.1562 156.642 60.2286C156.642 60.2576 156.642 60.2721 156.656 60.3011C156.671 60.3735 156.7 60.4459 156.729 60.4894C156.758 60.5329 156.787 60.5619 156.831 60.5763L158.144 61.3152L159.471 62.0542Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M159.311 61.764C159.311 61.7495 159.311 61.7205 159.296 61.6915C159.296 61.7205 159.311 61.735 159.311 61.764Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M159.34 61.0399C159.34 61.011 159.354 60.982 159.354 60.953C159.354 60.982 159.354 61.011 159.34 61.0399Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M162.329 56.2146C162.445 56.1422 162.533 56.1132 162.62 56.0987C162.533 56.1132 162.445 56.1422 162.329 56.2146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M162.693 56.0844C162.752 56.0844 162.795 56.0844 162.839 56.0988C162.795 56.0844 162.752 56.0844 162.693 56.0844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M159.456 60.6049C159.471 60.5614 159.485 60.518 159.5 60.4745C159.485 60.518 159.471 60.5614 159.456 60.6049Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M162.695 56.0844C162.666 56.0844 162.651 56.0844 162.622 56.0844C162.534 56.0988 162.432 56.1423 162.33 56.2003C161.499 56.6929 160.317 58.3735 159.676 59.9527C159.603 60.1266 159.544 60.3005 159.5 60.4598C159.486 60.5033 159.471 60.5468 159.457 60.5902C159.413 60.7061 159.384 60.822 159.369 60.938C159.369 60.9669 159.355 60.9959 159.355 61.0249C159.325 61.1553 159.311 61.2712 159.296 61.3871C159.296 61.4161 159.296 61.4306 159.296 61.4595C159.296 61.5465 159.296 61.6189 159.311 61.6914C159.311 61.7203 159.311 61.7348 159.325 61.7638C159.325 61.7783 159.325 61.7928 159.325 61.8073C159.34 61.8652 159.369 61.9087 159.384 61.9521C159.413 61.9956 159.442 62.0246 159.486 62.0391L166.473 65.9799C166.896 66.2262 167.319 66.458 167.712 66.6753C168.004 66.8347 168.311 66.9072 168.631 66.8927C168.952 66.8782 169.273 66.7913 169.594 66.6029C169.74 66.516 169.886 66.4001 170.017 66.2842C170.134 66.1827 170.236 66.0813 170.338 65.9654C170.367 65.9364 170.382 65.9219 170.411 65.893C170.542 65.7481 170.644 65.6032 170.761 65.4583C170.761 65.4583 170.761 65.4583 170.776 65.4438C170.892 65.2845 170.994 65.1251 171.096 64.9802C171.111 64.9512 171.126 64.9223 171.155 64.8933C171.228 64.7629 171.301 64.6325 171.359 64.5166C171.374 64.4731 171.403 64.4441 171.417 64.4152C171.578 64.1109 171.68 63.8791 171.695 63.8066C171.709 63.7487 171.724 63.7052 171.753 63.6473C171.782 63.5603 171.811 63.4734 171.84 63.401C171.855 63.343 171.884 63.2851 171.899 63.2416C171.913 63.2126 171.913 63.1836 171.928 63.1547C171.942 63.0967 171.942 63.0533 171.957 63.0098C171.972 62.9084 172.001 62.807 172.015 62.72C172.03 62.6476 172.03 62.5896 172.03 62.5172C172.03 62.4158 172.03 62.3288 172.03 62.2419C172.03 62.1984 172.03 62.1405 172.015 62.097C172.001 62.0101 171.986 61.9232 171.972 61.8362C171.957 61.7928 171.942 61.7493 171.942 61.7203C171.913 61.6479 171.899 61.5899 171.855 61.5175C171.826 61.4595 171.797 61.4161 171.767 61.3581C171.738 61.3146 171.724 61.2857 171.695 61.2422C171.505 60.9814 171.286 60.822 171.14 60.7496L168.69 59.3587C168.34 59.1559 167.99 58.9675 167.64 58.7647L165.379 57.4897C164.518 56.9971 163.672 56.5335 162.928 56.0988C162.928 56.0988 162.914 56.0988 162.899 56.0988C162.797 56.0844 162.753 56.0844 162.695 56.0844Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.7336 3.25988C64.7191 3.20193 64.7336 3.115 64.7482 3.01358C64.7482 2.98461 64.7628 2.97012 64.7628 2.94114C64.792 2.82523 64.8212 2.70933 64.8795 2.57893C65.1275 1.95593 65.5942 1.28947 65.9151 1.10112C65.988 1.05765 66.061 1.04316 66.1047 1.05765C64.7774 0.695442 63.4501 0.347721 62.1373 0C62.1227 0 62.1081 0 62.0935 0.0144884C62.0206 0.0579535 61.9185 0.202837 61.8747 0.333233C61.8602 0.376698 61.8456 0.420163 61.8456 0.44914C61.8456 0.463628 61.8456 0.463628 61.8456 0.463628C61.8456 0.478116 61.8456 0.492605 61.8456 0.507093C62.8229 1.46333 63.8001 2.41956 64.7774 3.3613C64.7482 3.33233 64.7336 3.30335 64.7336 3.25988Z",
    fill: "url(#paint15_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5672 8.96855C70.538 8.91059 70.5088 8.85264 70.4943 8.76571C70.4943 8.75122 70.4943 8.72224 70.4797 8.69327C70.4651 8.62083 70.4651 8.54838 70.4651 8.46145C70.4651 8.43248 70.4651 8.41799 70.4651 8.38901C70.4797 8.28759 70.4943 8.1572 70.5234 8.0268C70.5234 7.99783 70.538 7.96885 70.5526 7.92538C70.5818 7.82397 70.6109 7.70806 70.6401 7.57766C70.6547 7.5342 70.6693 7.49073 70.6839 7.44727C70.7422 7.2879 70.8006 7.12852 70.8589 6.94017C71.5007 5.36094 72.6822 3.6658 73.5136 3.18769C73.6303 3.11524 73.7178 3.08627 73.8053 3.07178C73.8345 3.07178 73.8491 3.07178 73.8782 3.07178C73.922 3.07178 73.9658 3.05729 73.9949 3.07178C73.9949 3.07178 73.9949 3.07178 73.9804 3.07178C71.3548 2.37634 68.7293 1.69538 66.1038 0.99994C66.0601 0.985452 66.0017 0.99994 65.9142 1.04341C65.5933 1.23175 65.1266 1.89822 64.8786 2.52122C64.8202 2.6661 64.7911 2.78201 64.7619 2.88343C64.7619 2.91241 64.7473 2.94138 64.7473 2.95587C64.7327 3.05729 64.7181 3.14422 64.7327 3.20217C64.7473 3.24564 64.7619 3.2891 64.7765 3.30359C66.7164 5.18708 68.6564 7.08506 70.6109 8.96855C70.6255 8.98304 70.6255 8.98304 70.6401 8.98304C70.6109 9.0265 70.5818 8.99752 70.5672 8.96855Z",
    fill: "url(#paint16_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0251 3.12941C74.0105 3.12941 74.0105 3.11492 73.996 3.11492C73.9668 3.10044 73.923 3.11492 73.8793 3.11492C73.9376 3.10044 73.9814 3.10044 74.0251 3.12941Z",
    fill: "url(#paint17_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.553 7.96851C70.553 7.99748 70.5384 8.02646 70.5238 8.06993C70.5384 8.02646 70.5384 7.99748 70.553 7.96851Z",
    fill: "url(#paint18_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6844 7.49048C70.6698 7.53394 70.6552 7.57741 70.6406 7.62087C70.6552 7.57741 70.6698 7.53394 70.6844 7.49048Z",
    fill: "url(#paint19_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5145 3.23108C73.6312 3.15864 73.7187 3.12966 73.8062 3.11517C73.7187 3.12966 73.6312 3.15864 73.5145 3.23108Z",
    fill: "url(#paint20_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4952 8.77996C70.4952 8.76547 70.4952 8.7365 70.4806 8.70752C70.4806 8.7365 70.4806 8.75098 70.4952 8.77996Z",
    fill: "url(#paint21_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.728 57.562C156.698 57.5186 156.669 57.4461 156.655 57.3737C156.655 57.3592 156.655 57.3302 156.64 57.3012C156.626 57.2288 156.626 57.1564 156.626 57.0694C156.626 57.0405 156.626 57.026 156.626 56.997C156.64 56.8956 156.655 56.7652 156.684 56.6348C156.684 56.6058 156.698 56.5768 156.698 56.5479C156.728 56.4319 156.757 56.316 156.786 56.2001C156.801 56.1567 156.815 56.1132 156.83 56.0697C156.888 55.9104 156.946 55.751 157.005 55.5626C157.647 53.9834 158.828 52.2883 159.659 51.8102C159.776 51.7377 159.864 51.7087 159.951 51.6942C159.951 51.6942 159.966 51.6942 159.966 51.6798C159.995 51.6798 160.01 51.6942 160.024 51.6942C160.082 51.6942 160.126 51.6942 160.17 51.7087C160.185 51.7087 160.185 51.7087 160.199 51.7087C158.157 50.5642 156.057 49.3761 153.912 48.1591L147.83 44.7253C144.096 42.6245 140.26 40.4513 136.351 38.249L129.554 34.4096C128.941 34.0619 128.328 33.7142 127.701 33.3665L113.713 25.4703C111.292 24.1084 108.885 22.7465 106.493 21.3991L104.713 20.3994C102.409 19.0954 100.119 17.8059 97.8433 16.531L86.4078 10.0836C84.3365 8.91008 82.2945 7.7655 80.2816 6.63541L74.0241 3.10024C74.0241 3.10024 74.0095 3.10024 73.9949 3.10024C73.9512 3.08575 73.9074 3.08575 73.8491 3.08575C73.8199 3.08575 73.8053 3.08575 73.7761 3.08575C73.6886 3.10024 73.5865 3.14371 73.4844 3.20166C72.653 3.69427 71.4715 5.37492 70.8297 6.95415C70.7568 7.12801 70.6985 7.30187 70.6547 7.46124C70.6401 7.50471 70.6255 7.54817 70.6109 7.59164C70.5672 7.70755 70.538 7.82345 70.5234 7.93936C70.5234 7.96834 70.5088 7.99731 70.4943 8.04078C70.4651 8.17117 70.4505 8.28708 70.4359 8.40299C70.4359 8.43196 70.4359 8.44645 70.4359 8.47543C70.4359 8.56236 70.4359 8.6348 70.4505 8.70724C70.4505 8.73622 70.4505 8.75071 70.4651 8.77969C70.4797 8.85213 70.5088 8.92457 70.538 8.98252C70.5526 9.0115 70.5818 9.02599 70.6109 9.05496C70.6255 9.05496 70.6255 9.06945 70.6401 9.08394C72.6676 10.2285 74.7826 11.4166 76.9122 12.6191L83.0092 16.0673C86.7432 18.1682 90.5648 20.3269 94.4739 22.5292L101.3 26.3831C101.913 26.7308 102.525 27.0785 103.138 27.4262L110.329 31.483C114.997 34.1199 119.693 36.7567 124.332 39.3791L126.17 40.4223C128.46 41.7118 130.735 43.0012 132.996 44.2762L144.461 50.738C146.532 51.9116 148.559 53.0562 150.558 54.1862L156.83 57.7214C156.801 57.6345 156.757 57.6055 156.728 57.562C156.728 57.5765 156.728 57.5765 156.728 57.562Z",
    fill: "url(#paint22_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.67 57.3738C156.67 57.3593 156.67 57.3304 156.656 57.3014C156.656 57.3304 156.656 57.3593 156.67 57.3738Z",
    fill: "#E4EEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.713 56.5629C156.713 56.5919 156.699 56.6209 156.699 56.6499C156.699 56.6209 156.713 56.5919 156.713 56.5629Z",
    fill: "#E4EEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.054 51.7088C160.113 51.7088 160.156 51.7088 160.2 51.7233C160.156 51.7088 160.113 51.6943 160.054 51.7088Z",
    fill: "#E4EEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.69 51.8255C159.806 51.7531 159.894 51.7241 159.981 51.7096C159.894 51.7241 159.792 51.7531 159.69 51.8255Z",
    fill: "#E4EEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.859 56.0844C156.845 56.1278 156.83 56.1713 156.816 56.2147C156.83 56.1713 156.845 56.1278 156.859 56.0844Z",
    fill: "#E4EEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.471 59.1566C159.428 59.1421 159.398 59.0987 159.369 59.0697C159.34 59.0262 159.325 58.9828 159.311 58.9248C159.311 58.9103 159.311 58.8958 159.311 58.8813C159.311 58.8668 159.311 58.8379 159.296 58.8089C159.282 58.7365 159.282 58.664 159.282 58.5771C159.282 58.5481 159.282 58.5336 159.282 58.5046C159.296 58.4032 159.311 58.2728 159.34 58.1424C159.34 58.1135 159.355 58.0845 159.355 58.0555C159.384 57.9396 159.413 57.8237 159.442 57.7078C159.457 57.6643 159.471 57.6209 159.486 57.5774C159.544 57.418 159.603 57.2586 159.661 57.0703C160.303 55.4911 161.484 53.7959 162.316 53.3178C162.432 53.2454 162.52 53.2164 162.607 53.2019C162.636 53.2019 162.651 53.2019 162.68 53.2019C162.739 53.2019 162.782 53.2019 162.826 53.2164C162.826 53.2164 162.841 53.2164 162.855 53.2164L161.528 52.4775C161.061 52.2167 160.609 51.9559 160.201 51.7386C160.201 51.7386 160.186 51.7386 160.171 51.7386C160.128 51.7241 160.084 51.7241 160.026 51.7241C160.011 51.7241 159.996 51.7096 159.967 51.7096C159.967 51.7096 159.953 51.7096 159.953 51.7241C159.865 51.7386 159.763 51.782 159.661 51.84C158.829 52.3326 157.648 54.0132 157.006 55.5925C156.933 55.7663 156.875 55.9402 156.831 56.0996C156.817 56.143 156.802 56.1865 156.787 56.23C156.744 56.3459 156.714 56.4618 156.7 56.5777C156.7 56.6067 156.685 56.6356 156.685 56.6646C156.656 56.795 156.642 56.9109 156.627 57.0268C156.627 57.0558 156.627 57.0703 156.627 57.0993C156.627 57.1862 156.627 57.2586 156.642 57.3311C156.642 57.3601 156.642 57.3745 156.656 57.4035C156.671 57.476 156.7 57.5484 156.729 57.5919C156.758 57.6353 156.787 57.6643 156.831 57.6788L158.144 58.4177L159.471 59.1566Z",
    fill: "#E4EEED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.311 58.8664C159.311 58.8519 159.311 58.8229 159.296 58.7939C159.296 58.8229 159.311 58.8374 159.311 58.8664Z",
    fill: "url(#paint23_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.34 58.1419C159.34 58.1129 159.354 58.084 159.354 58.055C159.354 58.084 159.354 58.1129 159.34 58.1419Z",
    fill: "url(#paint24_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.329 53.3171C162.445 53.2446 162.533 53.2157 162.62 53.2012C162.533 53.2157 162.445 53.2446 162.329 53.3171Z",
    fill: "url(#paint25_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.693 53.1866C162.752 53.1866 162.795 53.1866 162.839 53.2011C162.795 53.1866 162.752 53.1866 162.693 53.1866Z",
    fill: "url(#paint26_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.456 57.7073C159.471 57.6638 159.485 57.6204 159.5 57.5769C159.485 57.6204 159.471 57.6638 159.456 57.7073Z",
    fill: "url(#paint27_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.695 53.1866C162.666 53.1866 162.651 53.1866 162.622 53.1866C162.534 53.2011 162.432 53.2445 162.33 53.3025C161.499 53.7951 160.317 55.4758 159.676 57.055C159.603 57.2288 159.544 57.4027 159.5 57.5621C159.486 57.6055 159.471 57.649 159.457 57.6925C159.413 57.8084 159.384 57.9243 159.369 58.0402C159.369 58.0692 159.355 58.0981 159.355 58.1271C159.325 58.2575 159.311 58.3734 159.296 58.4893C159.296 58.5183 159.296 58.5328 159.296 58.5618C159.296 58.6487 159.296 58.7212 159.311 58.7936C159.311 58.8226 159.311 58.8371 159.325 58.866C159.325 58.8805 159.325 58.895 159.325 58.9095C159.34 58.9675 159.369 59.0109 159.384 59.0544C159.413 59.0978 159.442 59.1268 159.486 59.1413L166.473 63.0822C166.896 63.3285 167.319 63.5603 167.712 63.7776C168.004 63.937 168.311 64.0094 168.631 63.9949C168.952 63.9804 169.273 63.8935 169.594 63.7052C169.74 63.6182 169.886 63.5023 170.017 63.3864C170.134 63.285 170.236 63.1836 170.338 63.0677C170.367 63.0387 170.382 63.0242 170.411 62.9952C170.542 62.8503 170.644 62.7055 170.761 62.5606C170.761 62.5606 170.761 62.5606 170.776 62.5461C170.892 62.3867 170.994 62.2273 171.096 62.0825C171.111 62.0535 171.126 62.0245 171.155 61.9955C171.228 61.8651 171.301 61.7347 171.359 61.6188C171.374 61.5754 171.403 61.5464 171.417 61.5174C171.578 61.2132 171.68 60.9813 171.695 60.9089C171.709 60.8509 171.724 60.8075 171.753 60.7495C171.782 60.6626 171.811 60.5757 171.84 60.5032C171.855 60.4453 171.884 60.3873 171.899 60.3439C171.913 60.3149 171.913 60.2859 171.928 60.2569C171.942 60.199 171.942 60.1555 171.957 60.112C171.972 60.0106 172.001 59.9092 172.015 59.8223C172.03 59.7498 172.03 59.6919 172.03 59.6194C172.03 59.518 172.03 59.4311 172.03 59.3441C172.03 59.3007 172.03 59.2427 172.015 59.1993C172.001 59.1123 171.986 59.0254 171.972 58.9385C171.957 58.895 171.942 58.8515 171.942 58.8226C171.913 58.7501 171.899 58.6922 171.855 58.6197C171.826 58.5618 171.797 58.5183 171.767 58.4604C171.738 58.4169 171.724 58.3879 171.695 58.3445C171.505 58.0837 171.286 57.9243 171.14 57.8518L168.69 56.461C168.34 56.2581 167.99 56.0698 167.64 55.8669L165.379 54.592C164.518 54.0994 163.672 53.6357 162.928 53.2011C162.928 53.2011 162.914 53.2011 162.899 53.2011C162.797 53.1866 162.753 53.1866 162.695 53.1866Z",
    fill: "url(#paint28_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 46.1052,
    y1: 5.24475,
    x2: 103.169,
    y2: 73.0617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 46.2984,
    y1: 8.38714,
    x2: 99.751,
    y2: 71.8561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 44.6067,
    y1: 8.36568,
    x2: 99.154,
    y2: 73.1572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 125.645,
    y1: 55.3803,
    x2: 125.669,
    y2: 55.3803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 46.4451,
    y1: 9.98887,
    x2: 66.0871,
    y2: 33.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: -4.52193,
    y1: 8.69899,
    x2: 81.0833,
    y2: 110.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 76.2209,
    y1: 50.529,
    x2: 125.928,
    y2: 95.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 78.1773,
    y1: 72.7509,
    x2: 131.366,
    y2: 72.7509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1315,
    stopColor: "#BBCBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3184,
    stopColor: "#D2DBE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#E4E8EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7465,
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: -2.81427,
    y1: 36.3126,
    x2: 63.8358,
    y2: 100.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 7.47189,
    y1: 48.6494,
    x2: 132.38,
    y2: 115.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00454728,
    stopColor: "#B69BE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0217,
    stopColor: "#B79DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4637,
    stopColor: "#D7CBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8042,
    stopColor: "#EBE7F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 64.2555,
    y1: 34.7964,
    x2: 111.551,
    y2: 62.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 47.3099,
    y1: 15.448,
    x2: 99.8953,
    y2: 39.7522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 27.7965,
    y1: 9.68795,
    x2: 75.4083,
    y2: 30.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 23.0903,
    y1: 21.2252,
    x2: 43.8926,
    y2: 27.4933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 14.6429,
    y1: 25.3026,
    x2: 32.032,
    y2: 31.2832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 61.6923,
    y1: -0.0777679,
    x2: 65.6914,
    y2: 3.39731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 67.0442,
    y1: 6.98771,
    x2: 70.4336,
    y2: 1.06782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00454728,
    stopColor: "#B69BE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0217,
    stopColor: "#B79DE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4637,
    stopColor: "#D7CBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8042,
    stopColor: "#EBE7F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 73.874,
    y1: 3.10485,
    x2: 73.8871,
    y2: 3.1594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 70.5228,
    y1: 7.96616,
    x2: 70.569,
    y2: 7.97528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 70.6391,
    y1: 7.48746,
    x2: 70.7075,
    y2: 7.50322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 73.504,
    y1: 3.11249,
    x2: 73.6248,
    y2: 3.32102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 70.4801,
    y1: 8.70584,
    x2: 70.5037,
    y2: 8.7091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 70.4359,
    y1: 15.769,
    x2: 162.698,
    y2: 21.3582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7628"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 202.587,
    y1: -21.6954,
    x2: 231.856,
    y2: -77.0025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0175,
    stopColor: "#FED488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1738,
    stopColor: "#FED081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4049,
    stopColor: "#FCC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6824,
    stopColor: "#FAAF4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9935,
    stopColor: "#F7941F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 202.204,
    y1: -21.7837,
    x2: 231.487,
    y2: -77.0049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0175,
    stopColor: "#FED488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1738,
    stopColor: "#FED081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4049,
    stopColor: "#FCC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6824,
    stopColor: "#FAAF4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9935,
    stopColor: "#F7941F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 202.664,
    y1: -21.5827,
    x2: 231.933,
    y2: -76.8387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0175,
    stopColor: "#FED488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1738,
    stopColor: "#FED081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4049,
    stopColor: "#FCC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6824,
    stopColor: "#FAAF4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9935,
    stopColor: "#F7941F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 202.894,
    y1: -21.4836,
    x2: 232.16,
    y2: -76.7573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0175,
    stopColor: "#FED488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1738,
    stopColor: "#FED081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4049,
    stopColor: "#FCC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6824,
    stopColor: "#FAAF4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9935,
    stopColor: "#F7941F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 202.184,
    y1: -21.9137,
    x2: 231.484,
    y2: -77.2087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0175,
    stopColor: "#FED488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1738,
    stopColor: "#FED081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4049,
    stopColor: "#FCC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6824,
    stopColor: "#FAAF4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9935,
    stopColor: "#F7941F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 158.838,
    y1: 52.9365,
    x2: 171.536,
    y2: 63.1942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature389F5Be4);
export default __webpack_public_path__ + "static/media/feature-3.89f5be4.89f5be4a7361341b95a15828a4138186.svg";
export { ForwardRef as ReactComponent };